import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Properties as dxPopupOptions } from 'devextreme/ui/popup';
import { IBarcode } from '@services/grid/barcodes-data-grid.service';
import { IFactor } from '@services/grid/factors-data-grid.service';
import { formatFactorLabel } from 'src/app/utilities/factorsHelper';

export interface IBarcodeWithAssociatedFactor extends IBarcode {
  AssociatedFactor: IFactor;
}

@Component({
  selector: 'app-multi-item-barcode-selection-popup',
  templateUrl: './multi-item-barcode-selection-popup.component.html',
  styleUrls: ['./multi-item-barcode-selection-popup.component.scss']
})
export class MultiItemBarcodeSelectionPopupComponent {
  @Input() public visible = false;
  @Input() public title = 'Select Item';
  @Input() public barcodeItems: IBarcodeWithAssociatedFactor[] = [];
  @Input() public fullScreen = false;

  @Output() public itemSelected = new EventEmitter<IBarcodeWithAssociatedFactor>();
  @Output() public popupClosed = new EventEmitter<void>();

  public onItemClick(item: IBarcodeWithAssociatedFactor): void {
    this.itemSelected.emit(item);
  }

  public onPopupHiding(): void {
    this.popupClosed.emit();
  }

  public formatUnit(data: IBarcodeWithAssociatedFactor): string {
    if (!data.AssociatedFactor || !data.AssociatedFactor.Stock) {
      return '';
    }
    return formatFactorLabel(data.AssociatedFactor, data.AssociatedFactor.Stock);
  }
}
